import React from 'react';
import moment from 'moment';
import Box from '@material-ui/core/Box';
import { Query } from 'react-apollo';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Spin from 'components/common/Spin';
import {
  GET_INVOICE_DETAILS
} from 'graphql/payments';
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import {getFullName} from "../../../../utils";
import TableContainer from "@material-ui/core/TableContainer";

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: '90vw',
    maxWidth: 900,
    padding: 20,
  },
  close: {
    position: 'absolute',
    right: 10,
    top: 10,
  },
}));


const InvoiceDetails = ({ id, onClose }) => {
  const classes = useStyles();

  return (
    <Drawer open anchor="right" classes={{ paper: classes.drawer }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={3}
      >
        <Typography variant="h5">Invoice Details</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Query query={GET_INVOICE_DETAILS} variables={{ id }}>
        {({ data, loading, error }) => {
          if (loading) return <Spin spinning />;
          if (error) return error.message;

          const { id, payment_line_items, created_at, paid_at, total, status } = data.invoice;
          return (
            <>
              <Typography>ID: {id}</Typography>
              <Typography>Amount: ${total / 100}</Typography>
              <Typography>Status: {status}</Typography>
              <Typography>Created At: {moment(created_at).format('L')}</Typography>
              { paid_at && <Typography>Paid At: {moment(paid_at).format('L')}</Typography> }
              <Box marginTop={2}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Date</TableCell>
                        <TableCell>Item</TableCell>
                        <TableCell>Student/Group</TableCell>
                        <TableCell align="right">Duration</TableCell>
                        <TableCell align="right">Amount</TableCell>
                        <TableCell>Remark</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {payment_line_items.map((row) => (
                        <TableRow key={row.name}>
                          <TableCell scope="row">
                            {moment.utc(row.date).format('L')}
                          </TableCell>
                          <TableCell>{row.payment_category.label}</TableCell>
                          <TableCell>{row.student ? getFullName(row.student) : row.group?.name}</TableCell>
                          <TableCell align="right">
                            {row.duration}min
                          </TableCell>
                          <TableCell align="right">${row.total / 100}</TableCell>
                          <TableCell>{row.comments}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </>
          )
        }}
      </Query>
    </Drawer>

  )
}

export default InvoiceDetails;
